export const extractErrorMessage = (
  error: any,
  fallback: string = "Something went wrong"
) => {
  return error.response?.data?.errors?.join(". ") ?? fallback;
};
